document.addEventListener('scroll', function() {
  const header = document.querySelector('.header-wrapper');
  const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

  if (scrollTop > 5) {
    header.classList.add('header-scroll');
  } else {
    header.classList.remove('header-scroll');
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const menus = Array.from(document.querySelectorAll("details.mega-menu"));
  const headers = document.querySelector(".header");
  const nav = document.querySelector(".header__inline-menu");
  const closeTimers = new Map();

  function cancelDelayedClose(menu) {
    const t = closeTimers.get(menu);
    if (t) {
      clearTimeout(t);
      closeTimers.delete(menu);
    }
  }

  function removeHeaderClassIfNoOpen() {
    if (!menus.some(m => m.hasAttribute("open"))) {
      headers && headers.classList.remove("mega-open");
    }
  }

  function closeAllInstant() {
    menus.forEach(m => {
      cancelDelayedClose(m);
      m.removeAttribute("open");
    });
    headers && headers.classList.remove("mega-open");
  }

  function openMenu(menu) {
    menus.forEach(m => {
      if (m !== menu) {
        cancelDelayedClose(m);
        m.removeAttribute("open");
      }
    });
    cancelDelayedClose(menu);
    menu.setAttribute("open", "");
    headers && headers.classList.add("mega-open");
  }

  function delayedCloseMenu(menu) {
    cancelDelayedClose(menu);
    const id = setTimeout(() => {
      menu.removeAttribute("open");
      closeTimers.delete(menu);
      removeHeaderClassIfNoOpen();
    }, 1000);
    closeTimers.set(menu, id);
  }

  
  menus.forEach(menu => {
    const summary = menu.querySelector("summary.header__menu-item");
    const content = menu.querySelector(".mega-menu__content");
    if (!summary || !content) return;
    summary.addEventListener("mouseenter", () => openMenu(menu));
    content.addEventListener("mouseenter", () => openMenu(menu));
    menu.addEventListener("mouseleave", () => delayedCloseMenu(menu));

    menu.addEventListener("mouseenter", () => cancelDelayedClose(menu));
  });

  const plainTopLinks = nav?.querySelectorAll(".header__inline-menu > ul > li > a.header__menu-item");
  plainTopLinks?.forEach(link => {
    link.addEventListener("mouseenter", () => {
      closeAllInstant();
    });
  });
});


document.addEventListener("DOMContentLoaded", function () {
  const tabTile = document.querySelector(".tab-tile");
  const tabDetails = document.querySelectorAll(".tab-detail");

  if (tabTile && tabDetails.length > 0) {
    const detailsWrapper = document.createElement("div");
    detailsWrapper.classList.add("tab-details-wrapper");

    tabDetails.forEach(detail => {
      detailsWrapper.appendChild(detail);
    });

    const tabWrapper = document.createElement("div");
    tabWrapper.classList.add("tab-main-wrapper");

    tabTile.parentNode.insertBefore(tabWrapper, tabTile);

    tabWrapper.appendChild(tabTile);
    tabWrapper.appendChild(detailsWrapper);
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const details = document.querySelectorAll('.product__accordion details, .accordion details');
  if (!details.length) return; // nothing to do if no elements found

  details.forEach(detail => {
    detail.addEventListener('toggle', function () {
      if (this.open) {
        details.forEach(other => {
          if (other !== this && other.open) other.open = false;
        });
      }
    });
  });
});



document.addEventListener("DOMContentLoaded", function () {
  const trigger = document.querySelector(".title_arrow_wraapper"); 
  const target = document.querySelector(".filter_values");

  if (!trigger || !target) return;

  trigger.addEventListener("click", function () {
    target.classList.toggle("active");
  });
});


document.addEventListener('DOMContentLoaded', function () {
  new Swiper('.bundle-grid', {
    slidesPerView: '2.5',
    grabCursor: true,
    navigation: {
      nextEl: '.bundle-grid .swiper-button-next',
      prevEl: '.bundle-grid .swiper-button-prev',
    },
    breakpoints: {
      640: { slidesPerView: 2.5 },
      1024: { slidesPerView: 3.5 },
    },
  });
});


function multicolumnItemOpenClosePopup(){
  document.querySelectorAll('.popup_btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      // const parent = btn.closest('.multicolumn-card__content-container');
      const parent = btn.closest('.multicolumn-list__item');
      const hoverContent = parent.querySelector('.hover_content_wrapper');
      if (hoverContent) {
        hoverContent.classList.add('active');
      }
    });
  });

  document.querySelectorAll('.hover_content_wrapper .close_text').forEach(function(closeBTN){
    closeBTN.addEventListener('click', function(){
      var _parent = closeBTN.closest('.multicolumn-list__item'),
          _hoverContent = _parent.querySelector('.hover_content_wrapper');
      if(_hoverContent){
        _hoverContent.classList.remove('active');
      }
    });
  });
}
  
document.addEventListener('shopify:section:load',function(){
  multicolumnItemOpenClosePopup();
});

multicolumnItemOpenClosePopup();